import React from "react";
import Explainer from "../ExplainerModal";

const PolicyUpdatesAndCountryEventsExplainer = () => {
  return (
    <Explainer
      title="📢 Policy Updates & Country Events Explainer"
      content={
        <>
          <h3 style={{ fontSize: "20px", fontWeight: "bold", marginBottom: "10px", color: "#137A08" }}>
            📰 Policy Updates
          </h3>
          <p>
            This section provides timely updates on <strong>policy shifts</strong> and <strong>revisions</strong>.
            Each update includes a summary of the changes and a direct link to the full policy details for further reading.
          </p>

          <h3 style={{ fontSize: "20px", fontWeight: "bold", marginTop: "15px", marginBottom: "10px", color: "#137A08" }}>
            🌍 Country Events
          </h3>
          <p>
            Stay informed about key <strong>agri-food system events</strong>, including:
          </p>
          <ul>
            <li>🎤 <strong>Workshops</strong> – Engage with experts on policy discussions.</li>
            <li>🏛️ <strong>Conferences</strong> – Explore the latest policy trends and insights.</li>
            <li>📚 <strong>Training Sessions</strong> – Gain knowledge on policy implementation and governance.</li>
            <li>📢 <strong>Public Consultations</strong> – Share your feedback on ongoing policy formulation processes.</li>
          </ul>

          <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#333" }}>
            🌐 Public Access
          </h3>
          <p>
            The contents of this section are fully accessible to the <strong>general public</strong>.
            Anyone can view the latest policy updates and upcoming events, ensuring transparency and inclusivity.
          </p>
        </>
      }
    />
  );
};

export default PolicyUpdatesAndCountryEventsExplainer;
